module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Moviles-3-zoom.06f60e2e.png";